import React from 'react';
import Select from 'react-select';
import css from './FieldMultiSelect.module.css';
import classNames from 'classnames';
import { IconSpinner } from '..';

/**
 * We define a default styles object as a constant,
 * which can be used if no customStyles prop is provided.
 */
const defaultSelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    backgroundColor: '#fff',
    border: 'solid 1px #ddd',
    boxShadow: 'none',
    borderRadius: '6px',
    minHeight: '46px',
    '&:hover': {
      border: isFocused ? 'solid 1px #e5e5e6' : 'solid 1px #ddd',
    },
  }),
  placeholder: styles => ({
    ...styles,
    position: 'relative',
    bottom: '0px',
  }),
  valueContainer: styles => ({
    ...styles,
    minHeight: '46px',
    padding: '0 10px',
  }),
  option: (styles, { isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? '#ddd' : '#fff',
    color: isDisabled ? '#ccc' : '#313135',
    fontSize: '15px',
    padding: '10px 16px',
    cursor: isDisabled ? 'not-allowed' : 'default',
    '&:hover': {
      backgroundColor: '#eee',
      color: '#000',
    },
  }),
  Input: styles => ({ ...styles, margin: '0px', padding: '0px', maxHeight: 45 }),
  menu: styles => ({
    ...styles,
    backgroundColor: '#fff',
  }),
};

function FieldMultiSelect({
  input,
  options,
  label,
  isMulti = true,
  disabled = false,
  inProgress,
  onChange,
  customStyles = defaultSelectStyles,
  placeholder = 'Select...', // <-- Add placeholder prop
}) {
  const renderSpinner = inProgress ? (
    <span className={css.loader}>
      <IconSpinner />
    </span>
  ) : null;

  const handleChange = selectedOptions => {
    input.onChange(selectedOptions);
    if (onChange) {
      onChange(selectedOptions);
    }
  };

  const value = isMulti ? input.value || [] : input.value || null; // ✅ Do not default to first option

  return (
    <div className={classNames(css.reactSelect)}>
      {label && (
        <label>
          {label} {renderSpinner}
        </label>
      )}
      <Select
        value={value}
        onChange={handleChange}
        options={options}
        isMulti={isMulti}
        placeholder={placeholder} // ✅ Show "Select…" when no value
        styles={customStyles}
        isDisabled={disabled}
        components={{
          IndicatorSeparator: () => null,
        }}
      />
    </div>
  );
}

export default FieldMultiSelect;
